
            <div class="content-wrapper">
                <div class="page-header">
                    <h3 class="page-title" style="cursor: context-menu;">
                        <span class="page-title-icon bg-gradient-success text-white mr-2">
                            <i class="mdi mdi-file-document menu-icon"></i>
                        </span> สรุปผลการดำเนินงาน
                    </h3>
                    <nav aria-label="breadcrumb">
                        <button class="btn btn-inverse-info btn-fw" data-toggle="modal"
                            data-target="#edit_report">แก้ไขรายงาน</button>
                        <button class="btn btn-inverse-success btn-fw" style="margin-left: 10px;" data-toggle="modal"
                            data-target="#add_report">เพิ่มรายงาน</button>
                    </nav>
                    <div class="modal fade" id="edit_report" tabindex="-1" role="dialog"
                        aria-labelledby="เพิ่มผลการดำเนินงานรายปี" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="upload">แก้ไขผลการดำเนินงานรายปี
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <label>ปีงบประมาณ</label>
                                    <select class="form-control form-control-lg" [(ngModel)]="year_select"
                                        (change)="onSelectYear()">
                                        <option *ngFor="let year of performance_sum.fiscal_year" value="{{year}}">
                                            {{year}}
                                        </option>
                                    </select><br>
                                    <div *ngIf="year_select">
                                        <form [formGroup]="edit_report" *ngIf="edit_report">
                                            <label for="income"> รวมรายได้ <b style="color: red;"
                                                    *ngIf="!edit_report.value.total_income"> *</b></label>
                                            <input class="form-control" type="text" id="income" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="total_income" autocomplete="off" required><br>
                                            <label for="charge"> รวมค่าใช้จ่าย <b style="color: red;"
                                                    *ngIf="!edit_report.value.total_charge"> *</b></label>
                                            <input class="form-control" type="text" id="charge" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="total_charge" autocomplete="off" required><br>
                                            <label for="previous_error"> ผลสะสมแก้ไขข้อผิดพลาด(ปีก่อน) <b
                                                    style="color: red;" *ngIf="!edit_report.value.previous_error">
                                                    *</b></label>
                                            <input class="form-control" type="text" id="previous_error" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="previous_error" autocomplete="off" required>
                                            <div style="margin-top: 20px;">
                                                <div style="float: left;">
                                                    <button type="button" (click)="onClickDelete(edit_report.value)"
                                                        class="btn btn-inverse-danger btn-icon btn-sm">
                                                        <i class="mdi mdi-delete-forever"></i>
                                                    </button>
                                                </div>
                                                <div style="float: right;">
                                                    <button type="submit" class="btn btn-gradient-success"
                                                        (click)="onClickEdit()"
                                                        [disabled]="!edit_report.valid">บันทึก</button>
                                                    <button #closeModal type="reset" class="btn btn-gradient-light"
                                                        data-dismiss="modal" (click)="clear()"
                                                        style="margin-left: 10px;">ยกเลิก</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="add_report" tabindex="-1" role="dialog"
                        aria-labelledby="เพิ่มผลการดำเนินงานรายปี" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="upload">เพิ่มผลการดำเนินงานรายปี
                                    </h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <form [formGroup]="add_report">
                                        <div class="col-12">
                                            <label>ปีงบประมาณ <b style="color: red;"
                                                    *ngIf="!add_report.value.fiscal_year"> *</b></label>
                                            <select class="form-control form-control-lg" formControlName="fiscal_year"
                                                required>
                                                <option *ngFor="let year of fiscal_year" value="{{year}}">{{year}}
                                                </option>
                                            </select><br>
                                            <label for="total_income"> รวมรายได้ <span style="color: red;"
                                                    *ngIf="!add_report.value.total_income"> * <span style="font-size: 8pt; color: #a8a8a8;">(ค่าว่าง กรุณาใส่ 0)</span></span></label>
                                            <input class="form-control" type="text" id="total_income" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="total_income" autocomplete="off" required><br>
                                            <label for="total_charge"> รวมค่าใช้จ่าย <span style="color: red;"
                                                    *ngIf="!add_report.value.total_charge"> * <span style="font-size: 8pt; color: #a8a8a8;">(ค่าว่าง กรุณาใส่ 0)</span></span></label>
                                            <input class="form-control" type="text" id="total_charge" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="total_charge" autocomplete="off" required><br>
                                            <label for="high_low"> ผลสะสมแก้ไขข้อผิดพลาด(ปีก่อน) <span
                                                    style="color: red;" *ngIf="!add_report.value.previous_error">
                                                    * <span style="font-size: 8pt; color: #a8a8a8;">(ค่าว่าง กรุณาใส่ 0)</span></span></label>
                                            <input class="form-control" type="text" id="high_low" mask="separator"
                                                thousandSeparator="," [allowNegativeNumbers]="true"
                                                formControlName="previous_error" autocomplete="off" required>
                                        </div>
                                        <div style="float: right; margin-top: 20px;">
                                            <button type="submit" class="btn btn-gradient-success"
                                                (click)="onClickAdd()" [disabled]="!add_report.valid">บันทึก</button>
                                            <button type="button" class="btn btn-gradient-light" data-dismiss="modal"
                                                style="margin-left: 10px;" (click)="clearForm()"
                                                #closeAddModal>ยกเลิก</button>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 grid-margin">
                        <div class="card" style="border-radius: 15px;">
                            <div class="card-body" style="height: auto;">
                                <div echarts [options]="options" class="demo-chart"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 grid-margin">
                        <div class="card" style="border-radius: 15px;">
                            <div class="card-body" style="height: auto;">
                                <div id="print-section">
                                    <h4 class="h-left" style="text-align: center;">ตารางเปรียบเทียบผลการดำเนินงาน</h4>
                                    <br>
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-hover"
                                            style="cursor: context-menu; border: 1px solid #e6e9ed; text-align: center; border-collapse: collapse; width: 100%;">
                                            <thead style="font-weight: 450;">
                                                <tr>
                                                    <th
                                                        style="vertical-align: middle; border: 1px solid #e6e9ed; padding: 10px; font-weight: 500;">
                                                        ปีงบประมาณ </th>
                                                    <th
                                                        style="border: 1px solid #e6e9ed; padding: 10px; font-weight: 500;">
                                                        รวมรายได้ </th>
                                                    <th
                                                        style="border: 1px solid #e6e9ed; padding: 10px; font-weight: 500;">
                                                        รวมค่าใช้จ่าย </th>
                                                    <th
                                                        style="border: 1px solid #e6e9ed; padding: 10px; font-weight: 500;">
                                                        รายได้สูง(ต่ำ) กว่าค่าใช้จ่ายสุทธิ </th>
                                                    <th
                                                        style="border: 1px solid #e6e9ed; padding: 10px; font-weight: 500;">
                                                        รายได้สูง(ต่ำ) กว่าค่าใช้จ่ายสะสม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="font-weight: 400;" *ngFor="let data of all_performance">
                                                    <td
                                                        style="border: 1px solid #e6e9ed; padding: 10px; text-align: center; font-weight: 400;">
                                                        {{data.fiscal_year}} </td>
                                                    <td
                                                        style="border: 1px solid #e6e9ed; padding: 10px; text-align: right; font-weight: 400;">
                                                        <span *ngIf="data.total_income!=0">{{data.total_income|
                                                            number:'1.2-2'}}</span>
                                                    </td>
                                                    <td
                                                        style="border: 1px solid #e6e9ed; padding: 10px; text-align: right; font-weight: 400;">
                                                        <span *ngIf="data.total_charge!=0">{{data.total_charge|
                                                            number:'1.2-2'}}</span>
                                                    </td>
                                                    <td
                                                        style="border: 1px solid #e6e9ed; padding: 10px; text-align: right; font-weight: 400;">
                                                        <span *ngIf="data.highlow_net!=0">{{data.highlow_net|
                                                            number:'1.2-2'}}</span>
                                                    </td>
                                                    <td
                                                        style="border: 1px solid #e6e9ed; padding: 10px; text-align: right; font-weight: 400;">
                                                        <span *ngIf="data.highlow_cumulative!=0">{{data.highlow_cumulative|
                                                            number:'1.2-2'}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <br>
                                    <button class="btn btn-gradient-success btn-icon-text" style="margin-left: 50px;"
                                        printTitle="ตารางเปรียบเทียบผลการดำเนินงาน" printSectionId="print-section"
                                        ngxPrint><i class="mdi mdi-file-pdf btn-icon-prepend"></i>พิมพ์รายงาน</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>